export default "__VITE_ASSET__cba649f1__"